import {
    allMutualFundsMock,
    pricesAndYieldsAllMutualFundsMock
} from './Mocks/MFResearchToolMocks';
import { ComparePerformanceMock } from './Mocks/CompareMocks';
import {
    AverageAnnualTotalReturnsMock,
    ThirtyDayMock,
    PerformanceMock,
    TopTenIssuersMock,
    CalendarYearTotalReturnsMock
} from './Mocks/MFDetailPageMocks';
import { allETFsQueryMock } from './Mocks/ETFResearchToolMocks';
import {
    ETFPremiumDaysMock,
    ETFInvestmentObjectiveFundManagerMock,
    ETFInvestmentTeamFundManagerMock,
    MonthlyDistributionMock,
    ETFReturnsMock
} from './Mocks/ETFDetailPageMocks';
import { ThirtyDayPRTIXMock } from './Mocks/InflationVolatilityMock';
// import { ETFFundTypeMock } from './Mocks/FundTypeMocks';

const MOCK_DATA = {
    allMutualFundsMock,
    pricesAndYieldsAllMutualFundsMock,
    ComparePerformanceMock,
    AverageAnnualTotalReturnsMock,
    ThirtyDayMock,
    allETFsQueryMock,
    ETFPremiumDaysMock,
    ThirtyDayPRTIXMock,
    TopTenIssuersMock,
    PerformanceMock,
    CalendarYearTotalReturnsMock,
    ETFInvestmentObjectiveFundManagerMock,
    ETFInvestmentTeamFundManagerMock,
    MonthlyDistributionMock,
    // ETFFundTypeMock,
    ETFReturnsMock
};

export default MOCK_DATA;
